'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseMetadataSeries = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _ramda = require('ramda');

var R = _interopRequireWildcard(_ramda);

var _constants = require('./constants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dimensionValueDisplay = function dimensionValueDisplay(display) {
  return function (data) {
    if (display === 'code') {
      return R.prop('id', data);
    }
    var name = R.prop('name')(data);
    if (display === 'both') {
      return R.prop('id', data) + ': ' + name;
    }
    return name;
  };
};
// options = { locale, display, dimensions = [], attributes = { [id]: { format, parent } } };
var parseMetadataSeries = exports.parseMetadataSeries = function parseMetadataSeries(metadataJson, options) {
  var metadataAttributes = R.pathOr([], ['data', 'structures', 0, 'attributes', 'dimensionGroup'], metadataJson);
  var metaAttrLength = R.length(metadataAttributes);

  if (!metaAttrLength) {
    return {};
  }

  var dimensions = R.pipe(R.pathOr([], ['data', 'structures', 0, 'dimensions']), function (_ref) {
    var _ref$series = _ref.series,
        series = _ref$series === undefined ? [] : _ref$series,
        _ref$observation = _ref.observation,
        observation = _ref$observation === undefined ? [] : _ref$observation;
    return R.concat(series, observation);
  }, function (dims) {
    return R.isEmpty(options.dimensions || []) ? dims : R.props(R.pluck('id', options.dimensions), R.indexBy(R.prop('id'), dims));
  })(metadataJson);

  var metadataSeries = R.pipe(R.pathOr({}, ['data', 'dataSets', 0, 'dimensionGroupAttributes']), function (series) {
    return R.reduce(function (acc, serieKey) {
      var indexes = series[serieKey];
      var metaIndexes = R.take(metaAttrLength, indexes);

      var evolvedKey = R.pipe(R.split(':'), R.addIndex(R.map)(function (vInd, dInd) {
        if (R.isEmpty(vInd) || R.equals(_constants.EMPTY_ATTACHMENT_LEVEL_CHAR, vInd)) {
          return '';
        }
        var dim = R.nth(dInd, dimensions);
        var val = R.nth(Number(vInd), dim.values || []);

        var originalVal = R.find(R.propEq('id', val.id))(R.propOr([], 'values', R.nth(dInd, options.dimensions)));
        return R.propOr('', '__index', originalVal);
      }), R.join(':'))(serieKey);

      var attributes = R.pipe(R.addIndex(R.reduce)(function (acc, valueIndex, attrIndex) {
        var attribute = R.nth(attrIndex, metadataAttributes);
        if (R.isNil(valueIndex) && !attribute.isPresentational) {
          return acc;
        }
        var attrOptions = R.pathOr({}, ['attributes', attribute.id], options);
        var id = attrOptions.id;
        var label = dimensionValueDisplay(options.display)((0, _extends3.default)({}, attribute, { id: id }));

        var _value = R.prop('value', R.nth(valueIndex, attribute.values || []));
        var value = R.is(Object, _value) ? R.prop(options.locale, _value) : _value;

        return R.append((0, _extends3.default)({}, R.isNil(value) ? {} : { value: value }, {
          id: attribute.id,
          label: label,
          handlerProps: R.omit(['id'], R.pathOr({}, ['attributes', attribute.id], options))
        }), acc);
      }, []), function (attributes) {
        // missing parents in metadata response 
        var groupedAttrs = R.groupBy(R.pathOr('#ROOT', ['handlerProps', 'parent']), attributes);
        var indexedAttrs = R.indexBy(R.prop('id'), attributes);

        return R.reduce(function (acc, id) {
          if (R.has(id, indexedAttrs) || id === '#ROOT') {
            return acc;
          }
          return R.append({
            id: id,
            label: dimensionValueDisplay(options.display)({ id: id, name: R.path(['attributes', id, 'name'], options) }),
            handlerProps: R.omit(['id'], R.pathOr({}, ['attributes', id], options))
          }, acc);
        }, attributes, R.keys(groupedAttrs));
      }, function (attributes) {
        var groupedAttrs = R.groupBy(R.pathOr('#ROOT', ['handlerProps', 'parent']), attributes);
        var makeTree = R.map(function (attr) {
          if (R.has(attr.id, groupedAttrs)) {
            var children = makeTree(R.prop(attr.id, groupedAttrs));
            return R.assoc('children', children, attr);
          }
          return attr;
        });

        return makeTree(R.propOr([], '#ROOT', groupedAttrs));
      })(metaIndexes);

      return R.assoc(evolvedKey, attributes, acc);
    }, {}, R.keys(series));
  })(metadataJson);

  return metadataSeries;
};